import { inject, Injectable } from "@angular/core";
import { Translation, TranslocoLoader as TranslocoLoaderContract } from "@jsverse/transloco";
import { of } from "rxjs";
import { TranslationCacheService } from "./translation-cache.service";
import { unflattenTranslationKeys } from "./translation-flat.util";

@Injectable({ providedIn: "root" })
export class AppTranslocoLoader implements TranslocoLoaderContract {
  private readonly cache = inject(TranslationCacheService);

  getTranslation(locale: string) {
    const cached = this.cache.get(locale);

    return of(
      cached ? unflattenTranslationKeys(cached.translations) : ({} as Translation),
    );
  }
}
